export default {
  brandColor1: '#101820',
  complimentaryColor1: '#fff',
  brandColor2: '#EEBA04',
  complimentaryColor2: '#fff',
};
